import { serializeQueryFoldersSearchParams } from './queryFoldersUrlParams';

/** Preset shape for `QueryFolders` / POST `/folders/query` (matches FilterControls defaults + custom fields). */
export function buildQueryFoldersPresetFromNotification(
  filterDef: { fields?: { name: string }[] } | undefined,
  folderName: string
): Record<string, unknown> {
  const f: Record<string, unknown> = {
    isArchived: false,
    onlyWithData: false,
    backOfficeStatus: '',
    folderName,
    fileName: '',
    fileType: '',
    isPublished: '',
    isSigned: '',
    isLocked: '',
    fileStatus: '',
  };
  (filterDef?.fields || []).forEach((field) => {
    f[field.name] = '';
    f[`${field.name}_sort`] = '';
  });
  return f;
}

/** Query string for `/query-folders/:filterId?…` (e.g. from notifications: filter by folder name). */
export function buildQueryFoldersSearchFromNotification(
  filterDef: { fields?: { name: string }[] } | undefined,
  folderName: string,
  options?: { page?: number; itemsPerPage?: number }
): string {
  const empty = buildQueryFoldersPresetFromNotification(filterDef, '');
  const filters = buildQueryFoldersPresetFromNotification(
    filterDef,
    folderName
  );
  return serializeQueryFoldersSearchParams(
    filters,
    options?.page ?? 1,
    options?.itemsPerPage ?? 10,
    empty
  ).toString();
}
